import { DateShown } from "./DateShown";
import { DateSelected } from "./DateSelected";

/** compute the value prop to pass to primereact's Calendar component given the current date range and whether we are in the middle of selecting a range or not */
export const getDateSelected = (
    dateShown: DateShown,
    selectingDateRange: boolean
): DateSelected => {
    const [from, to] = dateShown;
    if (selectingDateRange) {
        return [from.toJSDate(), null];
    }
    return [from.toJSDate(), to.toJSDate()];
};
